// extracted by mini-css-extract-plugin
export default {"wrapper":"verify_wrapper__itA9t","vignette":"verify_vignette__x-1UD","icon":"verify_icon__VXgYe","cta":"verify_cta__GQgNA"};